<template>
  <div>
    <b-navbar toggleable="lg" type="light">
      <b-navbar-brand href="#">
        <img src="../../../static/logo.png" alt="" />
      </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <!-- <b-nav-item href="#" :to="{ name: 'index' }"><span style="color: #000;font-size: 25px;">首页</span></b-nav-item> -->
          <b-nav-item href="#" :to="{ name: 'ziuxn' }"><span style="color: #000;font-size: 25px;"
              :style="isActive==1?'color: #FFC107;':''">戏曲头条</span></b-nav-item>
          <!-- <b-nav-item href="#" :to="{ name: 'zhuanti' }"><span style="color: #000;font-size: 25px;">戏曲专题</span></b-nav-item> -->
          <b-nav-item href="#" :to="{ name: 'shortVideo' }"><span style="color: #000;font-size: 25px;"
              :style="isActive==2?'color: #FFC107;':''">名家名段</span></b-nav-item>
          <b-nav-item href="#" :to="{ name: 'langVideo' }"><span style="color: #000;font-size: 25px;"
              :style="isActive==3?'color: #FFC107;':''">全场戏曲</span></b-nav-item>
          <b-nav-item href="#" :to="{ name: 'downCenter' }"><span style="color: #000;font-size: 25px;"
              :style="isActive==4?'color: #FFC107;':''">下载中心</span></b-nav-item>
          <b-nav-item href="#" to=""><span style="color: #000;font-size: 25px;"
              @click="geiShang">戏迷商城</span></b-nav-item>
          <b-nav-item href="#" :to="{ name: 'about' }"><span style="color: #000;font-size: 25px;"
              :style="isActive==5?'color: #FFC107;':''">关于戏迷有约</span></b-nav-item>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <!-- <b-nav-item-dropdown text="Lang" right>
              <b-dropdown-item href="#">EN</b-dropdown-item>
              <b-dropdown-item href="#">ES</b-dropdown-item>
              <b-dropdown-item href="#">RU</b-dropdown-item>
              <b-dropdown-item href="#">FA</b-dropdown-item>
            </b-nav-item-dropdown> -->

          <!-- <b-nav-item-dropdown right>
              <template v-slot:button-content>
                <em>User</em>
              </template>
              <b-dropdown-item href="#">Profile</b-dropdown-item>
              <b-dropdown-item href="#">Sign Out</b-dropdown-item>
            </b-nav-item-dropdown> -->
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
  import {
    commonData
  } from '../../api/api.js'
  export default {
    props: ['isActive'],
    data() {
      return {}
    },
    created() {
      console.log(this.isActive);
    },
    methods: {
      geiShang() {
        commonData({}).then(res => {
          window.open(res.data.data.shop_url)
        })
      }
    }
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/navbar/navbar.vue